import React, { useEffect } from 'react';

const SuccessPopup = ({ isOpen, message, duration = 3000, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isOpen, duration, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1001] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full mx-4 text-center">
        {/* Green checkmark circle */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 bg-[#34C759] rounded-full flex items-center justify-center">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Success heading */}
        <h2 className="text-2xl font-semibold text-[#34C759] mb-3">
          Folder Created Successfully
        </h2>

        {/* Description text */}
        <p className="text-gray-600 text-base mb-6">
        You can now add files and manage them effectively
        </p>

        {/* Done button */}
        <button
          onClick={onClose}
          className="bg-green-500 hover:bg-[#34C759] text-white font-medium py-3 px-16 rounded-lg transition-colors duration-200"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default SuccessPopup;
